import React, { useState, useEffect, useCallback } from 'react';
import { WORKER_URL, getAuthHeaders } from '../../utils/api';

const DOR_LABEL = {
  'pedidos-atrasados':   '🔔 Alertas',
  'dashboard-tempo-real':'📊 Dashboard',
  'flex-cores':          '🟢 FLEX',
  'documentos-fiscais':  '📄 Documentos',
  'perguntas-clientes':  '💬 Perguntas',
  'fechar-mes':          '📈 Relatórios',
};

function SubscribersTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${WORKER_URL}/api/admin/subscribers`, { headers: getAuthHeaders() })
      .then(r => r.json()).then(setData).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <span style={{ fontSize: '0.95rem', fontWeight: 600, color: '#1a1a1a' }}>{data?.total || 0} inscrito{data?.total !== 1 ? 's' : ''} na newsletter</span>
      </div>
      <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem', minWidth: 400 }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e5e7eb' }}>
              {['Email', 'Origem', 'Data'].map(h => (
                <th key={h} style={{ padding: '10px 14px', textAlign: 'left', color: '#555', fontWeight: 600, fontSize: '0.78rem' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={3} style={{ padding: 40, textAlign: 'center', color: '#bbb' }}>Carregando...</td></tr>
            ) : !data?.subscribers?.length ? (
              <tr><td colSpan={3} style={{ padding: 48, textAlign: 'center', color: '#bbb' }}>Nenhum inscrito ainda.</td></tr>
            ) : data.subscribers.map((s, i) => (
              <tr key={s.id} style={{ borderBottom: i < data.subscribers.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                <td style={{ padding: '10px 14px', color: '#1a1a1a' }}>{s.email}</td>
                <td style={{ padding: '10px 14px' }}>
                  <span style={{ fontSize: '0.75rem', background: '#f0f9ff', color: '#0369a1', padding: '3px 9px', borderRadius: 20, fontWeight: 600 }}>{s.source}</span>
                </td>
                <td style={{ padding: '10px 14px', color: '#777', whiteSpace: 'nowrap' }}>{new Date(s.created_at).toLocaleDateString('pt-BR')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function EditModal({ post, onClose, onSaved }) {
  const [form, setForm] = useState({
    title: post.title || '',
    summary: post.summary || '',
    content: post.content || '',
    meta_title: post.meta_title || '',
    meta_description: post.meta_description || '',
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    setSaving(true); setMsg('');
    try {
      const res = await fetch(`${WORKER_URL}/api/admin/blog/${post.id}`, {
        method: 'PUT',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const d = await res.json();
      if (d.ok) { setMsg('Salvo!'); onSaved(); }
      else setMsg(d.error || 'Erro ao salvar');
    } catch { setMsg('Erro de conexão'); }
    setSaving(false);
  };

  const field = (label, key, multiline = false, rows = 3) => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>{label}</label>
      {multiline ? (
        <textarea value={form[key]} onChange={e => set(key, e.target.value)} rows={rows}
          style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, fontFamily: key === 'content' ? 'monospace' : 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
      ) : (
        <input type="text" value={form[key]} onChange={e => set(key, e.target.value)}
          style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' }} />
      )}
    </div>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 780, maxHeight: '90vh', overflow: 'auto', boxShadow: '0 24px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: '1px solid #e5e7eb' }}>
          <span style={{ fontWeight: 700, fontSize: 16, color: '#1a1a1a' }}>Editar artigo</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '24px 24px 8px' }}>
          {field('Título', 'title')}
          {field('Resumo', 'summary', true, 2)}
          {field('Conteúdo (HTML)', 'content', true, 18)}
          {field('Meta título (SEO, até 60 chars)', 'meta_title')}
          {field('Meta descrição (SEO, 150-160 chars)', 'meta_description', true, 2)}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10, padding: '12px 24px 20px' }}>
          {msg && <span style={{ fontSize: 13, color: msg === 'Salvo!' ? '#16a34a' : '#dc2626', marginRight: 8 }}>{msg}</span>}
          <button onClick={onClose} style={{ padding: '8px 18px', background: '#f3f4f6', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#555' }}>
            Cancelar
          </button>
          <button onClick={handleSave} disabled={saving}
            style={{ padding: '8px 22px', background: '#1B2A7A', color: '#FFD400', border: 'none', borderRadius: 7, cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 700, opacity: saving ? 0.7 : 1 }}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}

function BlogTab() {
  const [posts, setPosts] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalViews, setTotalViews] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [genMsg, setGenMsg] = useState('');
  const [editPost, setEditPost] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(null);

  const fetchPosts = useCallback(async (p = page) => {
    setLoading(true);
    try {
      const res = await fetch(`${WORKER_URL}/api/admin/blog?page=${p}`, { headers: getAuthHeaders() });
      const d = await res.json();
      setPosts(d.posts || []); setTotal(d.total || 0); setTotalViews(d.total_views || 0); setPages(d.pages || 1);
    } catch {}
    setLoading(false);
  }, [page]);

  useEffect(() => { fetchPosts(page); }, [page]);

  const [hubTheme, setHubTheme] = useState('');

  const handleGenerate = async (type = 'regular') => {
    setGenerating(true); setGenMsg('');
    try {
      const body = type === 'hub' ? { type: 'hub', theme: hubTheme } : {};
      const res = await fetch(`${WORKER_URL}/api/admin/blog/generate`, {
        method: 'POST', headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const d = await res.json();
      if (d.ok) { setGenMsg(`✓ "${d.title}" publicado!`); fetchPosts(1); setPage(1); }
      else setGenMsg(`✗ ${d.error || 'Erro ao gerar'}`);
    } catch { setGenMsg('✗ Erro de conexão'); }
    setGenerating(false);
  };

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Excluir "${title}"?`)) return;
    await fetch(`${WORKER_URL}/api/admin/blog/${id}`, { method: 'DELETE', headers: getAuthHeaders() });
    fetchPosts(page);
  };

  const handleEdit = async (post) => {
    setLoadingEdit(post.id);
    try {
      const res = await fetch(`${WORKER_URL}/api/blog/${post.slug}`);
      const full = await res.json();
      setEditPost({ ...post, ...full });
    } catch { setEditPost(post); }
    setLoadingEdit(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <span style={{ fontSize: '0.95rem', fontWeight: 600, color: '#1a1a1a' }}>{total} artigo{total !== 1 ? 's' : ''} publicados</span>
          <span style={{ fontSize: '0.8rem', color: '#aaa', marginLeft: 10 }}>· geração automática todo dia às 3h</span>
          {totalViews > 0 && (
            <span style={{ fontSize: '0.8rem', color: '#1B2A7A', fontWeight: 600, marginLeft: 14, background: '#EEF2FF', padding: '2px 10px', borderRadius: 20 }}>
              {totalViews.toLocaleString('pt-BR')} visualizações totais
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {genMsg && <span style={{ fontSize: '0.8rem', color: genMsg.startsWith('✓') ? '#16a34a' : '#dc2626' }}>{genMsg}</span>}
          <button onClick={() => handleGenerate('regular')} disabled={generating}
            style={{ padding: '7px 18px', background: '#1B2A7A', color: '#FFD400', border: 'none', borderRadius: 7, cursor: generating ? 'not-allowed' : 'pointer', fontSize: '0.84rem', fontWeight: 700, opacity: generating ? 0.6 : 1 }}>
            {generating ? 'Gerando...' : '+ Gerar post'}
          </button>
          <select value={hubTheme} onChange={e => setHubTheme(e.target.value)}
            style={{ padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: '0.82rem', color: hubTheme ? '#1a1a1a' : '#9ca3af' }}>
            <option value="">Tema do Hub...</option>
            <option value="pedidos-atrasados">Alertas / FLEX</option>
            <option value="dashboard-tempo-real">Dashboard</option>
            <option value="flex-cores">FLEX Cores</option>
            <option value="documentos-fiscais">Documentos Fiscais</option>
            <option value="perguntas-clientes">Perguntas Clientes</option>
            <option value="fechar-mes">Fechar Mês</option>
          </select>
          <button onClick={() => handleGenerate('hub')} disabled={generating || !hubTheme}
            style={{ padding: '7px 16px', background: hubTheme ? '#7c3aed' : '#e5e7eb', color: hubTheme ? '#fff' : '#aaa', border: 'none', borderRadius: 7, cursor: (generating || !hubTheme) ? 'not-allowed' : 'pointer', fontSize: '0.84rem', fontWeight: 700, opacity: generating ? 0.6 : 1 }}>
            ★ Gerar Hub
          </button>
        </div>
      </div>

      <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem', minWidth: 600 }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e5e7eb' }}>
              {['Título', 'Tema', 'Publicado em', 'Views', 'Ações'].map(h => (
                <th key={h} style={{ padding: '10px 14px', textAlign: 'left', color: '#555', fontWeight: 600, fontSize: '0.78rem' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding: 40, textAlign: 'center', color: '#bbb' }}>Carregando...</td></tr>
            ) : posts.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: 48, textAlign: 'center', color: '#bbb' }}>Nenhum artigo publicado. Clique em "Gerar agora".</td></tr>
            ) : posts.map((p, i) => (
              <tr key={p.id} style={{ borderBottom: i < posts.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                <td style={{ padding: '10px 14px', fontWeight: 500, color: '#1a1a1a', maxWidth: 380 }}>
                  <a href={`/blog/${p.slug}`} target="_blank" rel="noreferrer" style={{ color: '#1B2A7A', textDecoration: 'none' }}>{p.title}</a>
                </td>
                <td style={{ padding: '10px 14px' }}>
                  <span style={{ fontSize: '0.75rem', background: '#EEF2FF', color: '#1B2A7A', padding: '3px 9px', borderRadius: 20, fontWeight: 600 }}>
                    {DOR_LABEL[p.dor_tema] || p.dor_tema || '—'}
                  </span>
                  {p.post_type === 'hub' && (
                    <span style={{ fontSize: '0.7rem', background: '#f5f3ff', color: '#7c3aed', padding: '2px 7px', borderRadius: 20, fontWeight: 700, marginLeft: 5 }}>Hub</span>
                  )}
                </td>
                <td style={{ padding: '10px 14px', color: '#777', whiteSpace: 'nowrap' }}>
                  {new Date(p.published_at).toLocaleDateString('pt-BR')}
                </td>
                <td style={{ padding: '10px 14px', whiteSpace: 'nowrap' }}>
                  <span style={{ fontSize: '0.82rem', fontWeight: 600, color: p.views > 0 ? '#1B2A7A' : '#bbb' }}>
                    {(p.views || 0).toLocaleString('pt-BR')}
                  </span>
                </td>
                <td style={{ padding: '10px 14px', display: 'flex', gap: 8 }}>
                  <a href={`/blog/${p.slug}`} target="_blank" rel="noreferrer"
                    style={{ padding: '4px 12px', background: '#f0f7ff', color: '#1B2A7A', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600, textDecoration: 'none' }}>
                    Ver
                  </a>
                  <button onClick={() => handleEdit(p)} disabled={loadingEdit === p.id}
                    style={{ padding: '4px 12px', background: '#f0fdf4', color: '#16a34a', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600, opacity: loadingEdit === p.id ? 0.6 : 1 }}>
                    {loadingEdit === p.id ? '...' : 'Editar'}
                  </button>
                  <button onClick={() => handleDelete(p.id, p.title)}
                    style={{ padding: '4px 12px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600 }}>
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editPost && (
        <EditModal
          post={editPost}
          onClose={() => setEditPost(null)}
          onSaved={() => { fetchPosts(page); setEditPost(null); }}
        />
      )}

      {pages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
            style={{ padding: '6px 16px', border: '1px solid #e5e7eb', borderRadius: 6, background: '#fff', cursor: page === 1 ? 'not-allowed' : 'pointer', fontSize: '0.82rem', opacity: page === 1 ? 0.5 : 1 }}>
            ← Anterior
          </button>
          <span style={{ padding: '6px 12px', fontSize: '0.82rem', color: '#777' }}>{page} / {pages}</span>
          <button onClick={() => setPage(p => Math.min(pages, p + 1))} disabled={page === pages}
            style={{ padding: '6px 16px', border: '1px solid #e5e7eb', borderRadius: 6, background: '#fff', cursor: page === pages ? 'not-allowed' : 'pointer', fontSize: '0.82rem', opacity: page === pages ? 0.5 : 1 }}>
            Próxima →
          </button>
        </div>
      )}
    </div>
  );
}

const STATUS = {
  trial:   { label: 'Trial',     color: '#2D3277', bg: '#e8eaf6' },
  active:  { label: 'Ativo',     color: '#16a34a', bg: '#f0fdf4' },
  warning: { label: 'Aviso',     color: '#d97706', bg: '#fffbeb' },
  blocked: { label: 'Bloqueado', color: '#dc2626', bg: '#fef2f2' },
  pending: { label: 'Pendente',  color: '#6b7280', bg: '#f9fafb' },
};

const fmt = d => d ? new Date(d).toLocaleDateString('pt-BR') : '—';

export default function Admin() {
  const [tab, setTab] = useState('users');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [actionLoading, setActionLoading] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(`${WORKER_URL}/api/admin/users`, { headers: getAuthHeaders() });
      if (res.ok) { setData(await res.json()); setLastUpdate(new Date()); }
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
    const t = setInterval(fetchData, 30000);
    return () => clearInterval(t);
  }, [fetchData]);

  const handleToggle = async (id, currentlyBlocked) => {
    setActionLoading(id);
    try {
      await fetch(`${WORKER_URL}/api/admin/user/${id}/${currentlyBlocked ? 'unblock' : 'block'}`, {
        method: 'POST', headers: getAuthHeaders(),
      });
      await fetchData();
    } catch {}
    setActionLoading(null);
  };

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Carregando...</div>;
  if (!data) return <div style={{ padding: 40, color: '#dc2626' }}>Erro ao carregar dados.</div>;

  const { users, summary } = data;

  const cards = [
    { label: 'Total',      value: summary.total,    color: '#2D3277' },
    { label: 'Trial',      value: summary.trial,    color: '#7c3aed' },
    { label: 'Ativos',     value: summary.active,   color: '#16a34a' },
    { label: 'Aviso',      value: summary.warning,  color: '#d97706' },
    { label: 'Bloqueados', value: summary.blocked,  color: '#dc2626' },
    { label: 'Fundadores', value: summary.founders, color: '#b45309' },
  ];

  return (
    <div style={{ padding: '28px 32px', maxWidth: 1200, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <h2 style={{ color: '#2D3277', margin: 0, fontSize: '1.3rem', fontWeight: 700 }}>Painel Admin</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {lastUpdate && (
            <span style={{ color: '#aaa', fontSize: '0.78rem' }}>
              Atualizado às {lastUpdate.toLocaleTimeString('pt-BR')} · auto 30s
            </span>
          )}
          <button
            onClick={fetchData}
            style={{ padding: '6px 16px', background: '#2D3277', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600 }}
          >
            ↻ Atualizar
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 24, borderBottom: '2px solid #e5e7eb', paddingBottom: 0 }}>
        {[['users', '👥 Usuários'], ['blog', '📝 Blog'], ['subscribers', '📧 Newsletter']].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)}
            style={{ padding: '8px 20px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '0.9rem', fontWeight: tab === key ? 700 : 500, color: tab === key ? '#2D3277' : '#888', borderBottom: tab === key ? '2px solid #2D3277' : '2px solid transparent', marginBottom: -2, transition: 'color 0.15s' }}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'blog' && <BlogTab />}
      {tab === 'subscribers' && <SubscribersTab />}
      {tab === 'users' && <>

      {/* Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 28 }}>
        {cards.map(c => (
          <div key={c.label} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 10, padding: '18px 12px', textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ fontSize: '2rem', fontWeight: 700, color: c.color, lineHeight: 1 }}>{c.value}</div>
            <div style={{ fontSize: '0.75rem', color: '#888', marginTop: 6, fontWeight: 500 }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'auto', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem', minWidth: 860 }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e5e7eb' }}>
              {['Nome', 'Email', 'Cadastro', 'Status', 'Fundador', 'Vencimento', 'Celular', 'Ações'].map(h => (
                <th key={h} style={{ padding: '11px 14px', textAlign: 'left', color: '#555', fontWeight: 600, fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((u, i) => {
              const st = STATUS[u.status] || STATUS.pending;
              return (
                <tr
                  key={u.id}
                  style={{
                    borderBottom: i < users.length - 1 ? '1px solid #f1f5f9' : 'none',
                    background: u.is_blocked ? '#fffafa' : 'white',
                  }}
                >
                  <td style={{ padding: '10px 14px', fontWeight: 500, color: '#1a1a1a' }}>
                    {u.name}
                    {u.is_admin ? <span style={{ marginLeft: 6, fontSize: '0.7rem', background: '#e8eaf6', color: '#2D3277', padding: '1px 6px', borderRadius: 10, fontWeight: 700 }}>admin</span> : null}
                  </td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{u.email}</td>
                  <td style={{ padding: '10px 14px', color: '#777', whiteSpace: 'nowrap' }}>{fmt(u.created_at)}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span style={{ background: st.bg, color: st.color, padding: '3px 10px', borderRadius: 20, fontSize: '0.74rem', fontWeight: 600, whiteSpace: 'nowrap' }}>
                      {st.label}{u.trialDaysLeft ? ` · ${u.trialDaysLeft}d` : ''}
                    </span>
                  </td>
                  <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                    {u.is_early_adopter
                      ? <span style={{ color: '#b45309', fontWeight: 700, fontSize: '0.8rem' }}>★ Sim</span>
                      : <span style={{ color: '#ddd' }}>—</span>}
                  </td>
                  <td style={{ padding: '10px 14px', color: '#777', whiteSpace: 'nowrap' }}>
                    {u.dueDate ? fmt(u.dueDate) : '—'}
                  </td>
                  <td style={{ padding: '10px 14px', color: '#999' }}>{u.phone || '—'}</td>
                  <td style={{ padding: '10px 14px' }}>
                    {!u.is_admin && (
                      <button
                        onClick={() => handleToggle(u.id, u.is_blocked)}
                        disabled={actionLoading === u.id}
                        style={{
                          padding: '4px 14px', border: 'none', borderRadius: 6, cursor: 'pointer',
                          fontSize: '0.78rem', fontWeight: 600, transition: 'opacity 0.15s',
                          background: u.is_blocked ? '#f0fdf4' : '#fef2f2',
                          color: u.is_blocked ? '#16a34a' : '#dc2626',
                          opacity: actionLoading === u.id ? 0.5 : 1,
                        }}
                      >
                        {actionLoading === u.id ? '...' : u.is_blocked ? 'Desbloquear' : 'Bloquear'}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {users.length === 0 && (
          <div style={{ padding: 48, textAlign: 'center', color: '#bbb' }}>Nenhum usuário cadastrado.</div>
        )}
      </div>

      <p style={{ marginTop: 12, color: '#bbb', fontSize: '0.75rem', textAlign: 'right' }}>
        {users.length} usuário{users.length !== 1 ? 's' : ''} · atualização automática a cada 30 segundos
      </p>
      </>}
    </div>
  );
}
